<template>
    <div class="page-container"></div>
    <el-container class="app-wrapper">
        <el-header>
            <Header></Header>
        </el-header>
        <div class="app-container"></div>
    </el-container>
</template>

<script setup>
import { onBeforeMount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router/index.js'
import Header from '@/layout/components/Header.vue'
import { setItem } from '@/utils/storage'
const path = require('path')

const store = useStore()

const userInfo = ref({})
const allMenus = ref([])
const getFirstLeafNode = (nodes, path) => {
    for (const node of nodes) {
        if (path) node.fullpath = path
        if (!node.children || !node.children.length) {
            node.fullpath.push(node.path)
            console.log(node.fullpath)
            return node
        } else {
            const pathArr = node.fullpath ? [...node.fullpath, node.path] : [node.path]
            const result = getFirstLeafNode(node.children, pathArr)
            if (result) return result
        }
    }
    return null
}
onBeforeMount(() => {
    userInfo.value = store.state.user.userInfo
    console.log(userInfo.value)
    allMenus.value = store.getters.userInfo && store.getters.userInfo.auths && store.getters.userInfo.auths.menus
    console.log(allMenus.value)
})
onMounted(async () => {
    if (userInfo.value.username && allMenus.value) {
        if (userInfo.value.is_system_admin) {
            router.replace('/system/school-manage').then(() => {})
        } else {
            const arr = Object.keys(allMenus.value)
            const menuList = allMenus.value[arr[arr.length - 1]]
            setItem('subsystem', arr[arr.length - 1])
            store.dispatch('permission/saveMenu', menuList || [])
            const data = await store.dispatch('user/getUserInfo')
            localStorage.setItem('userInfo', JSON.stringify(data))
            const firstLeafNode = getFirstLeafNode(menuList)
            const path_list = firstLeafNode?.fullpath?.map((ele, index) => {
                if (index === 0 && !ele.includes('/')) {
                    return '/' + ele
                }
                if (index > 0 && ele.includes('/')) {
                    return ele.replace(/^\//, '')
                }
                return ele
            }) || ['/index']
            const query = firstLeafNode.query ? JSON.parse(firstLeafNode.query.slice(1, -1)) : ''
            const link = path.resolve(...path_list)
            router.push({
                path: link,
                query
            })
        }
    }
})
</script>
<style scoped lang="scss">
.app-wrapper {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);

    .el-header {
        width: 100%;
        height: 60px;
        border-radius: 15px;
    }

    .app-container {
        width: 100%;
        height: calc(100% - 60px);
    }
}
</style>
